import EnumSealTimestampLevel from "./gen/qsign/types/EnumSealTimestampLevel";

const labels = {
    [EnumSealTimestampLevel.QUALIFIED]: "Kvalifikovaný",
    [EnumSealTimestampLevel.GUARANTEED]: "Zaručený",
    [EnumSealTimestampLevel.NONE]: "Žádný",
};

export function getCaption(source: EnumSealTimestampLevel) {
    const caption = labels[source];
    return caption ? caption : "[" + source + "]";
}
